<template>
  <v-container>
    <v-card elevation="12" style="margin-top: 10px">
      <v-card-title class="justify-center" style="text-align: center">
        {{ $t('CERTIFICATE ') }}
      </v-card-title>
      <v-card-text>
        <div class="container">
          <div class="row">
            <div class="col">
              <strong>PATATA {{ $t('Date') }}:</strong>
            </div>
            <div class="col">
              {{ date }}
            </div>
          </div>
          <div class="row">
            <div class="col">
              <strong>{{ $t('Certificate number') }}:</strong>
            </div>
            <div class="col">
              {{ certificateNumber }}
            </div>
          </div>
          <div class="row">
            <div class="col">
              <strong>{{ $t('Debtor (A)') }}:</strong>
            </div>
            <div class="col">
              {{ getName(payer) }}
            </div>
          </div>
          <div class="row">
            <div class="col">
              <strong>{{ $t('Creditor (B)') }}:</strong>
            </div>
            <div class="col">
              {{ getName(middle) }}
            </div>
          </div>
          <div class="row">
            <div class="col">
              <strong>{{ $t('Beneficiary (C)') }}:</strong>
            </div>
            <div class="col">
              {{ getName(receiver) }}
            </div>
          </div>

          <div class="row">
            <div class="col">
              <strong>{{ $t('Compensated ammount') }}:</strong>
            </div>
            <div class="col">
              <div>
                {{ compensated }}
              </div>
              <div>
                ({{ $t('Quantity that A deduces from his debt with B through a payment to C') }})
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <strong>{{ $t('Payment from debtor (A) to beneficiary (C)') }}:</strong>
            </div>
            <div class="col">
              <div>
                {{ payment }}
              </div>
              <div>
                {{ $t('To the following account') }}: {{ account }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <strong>{{ $t('Manifested agreement') }}:</strong>
            </div>
          </div>
          <div class="row">
            <div class="col">
              {{ $t('certificate.middle', {amount: factoring.formulaCalc.ABini, invoiceNumberAB: invoiceNumberAB}) }}
              <a :href="invoiceLinkAB" target="_blank">link</a> ]
                {{ $t('certificate.middleP2', {amount: factoring.formulaCalc.ABini, invoiceNumberAB: invoiceNumberAB}) }}
            </div>
          </div>
          <div class="row">
            <div class="col">
              {{ $t('certificate.receiver', {amount: factoring.formulaCalc.ACclc, invoiceNumberBC: invoiceNumberBC }) }}
              <a :href="invoiceLinkBC" target="_blank">link</a> ]
            </div>
          </div>
          <div class="row">
            <div class="col">
              {{ $t('certificate.payer', {amount: factoring.formulaCalc.earnA}) }}
            </div>
          </div>
          <div class="row">
            <div class="col">
              {{ $t('This certificate reflects the agreement executed by the three parties') }}
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-row justify="center" style="margin-bottom: 10px">
          <v-btn color="primary" @click="goBack">
            {{ $t('Back') }}
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import {User} from "../models/user";
import moment from "moment";
import Constants from "../../constants";

export default {
    name: "Certificate",
    data () {
        return {
            factoring: null,
            date: "",
            certificateNumber: "",
            payer: null,
            middle: null,
            receiver: null,
            compensated: 0,
            payment: 0,
            account: "",
            invoiceNumberAB: "",
            invoiceLinkAB: "",
            invoiceLinkCompensated: "",
            invoiceNumberBC: "",
            invoiceLinkBC: "",
            invoiceLinkCleared: "",
            bonus: 0
        };
    },
    created () {
        this.fetch();
    },
    methods: {
        fetch () {
            ApiRepository.getFactoringById(this.$route.params.id)
                .then((res) => {
                    if (res.data && res.data.factoring) {
                        this.factoring = res.data.factoring;
                        this.date = moment(this.factoring.created).format("DD/MM/YYYY ");
                        if (this.factoring.hash.length > 0) this.certificateNumber = this.factoring.hash[0];
                        console.log(this.factoring.payer);
                        this.payer = new User(this.factoring.payer);
                        console.log(this.payer);
                        this.middle = new User(this.factoring.middle);
                        console.log(this.middle);
                        this.receiver = new User(this.factoring.receiver);
                        console.log(this.receiver);
                        this.compensated = this.factoring.compensation;
                        if (this.factoring.invoice_receiver.amount < this.factoring.invoice_payer.amount) this.compensated = this.factoring.invoice_receiver.amount;
                        else this.compensated = this.factoring.invoice_payer.amount;
                        this.payment = this.factoring.compensation;
                        this.account = this.factoring.invoice_receiver.accountNumber;
                        this.invoiceNumberAB = this.factoring.invoice_payer.number;
                        this.invoiceNumberBC = this.factoring.invoice_receiver.number;
                        this.invoiceLinkAB = "/viewInvoice?invoiceId=" + this.factoring.invoice_payer._id;
                        this.invoiceLinkBC = "/viewInvoice?invoiceId=" + this.factoring.invoice_receiver._id;
                        this.invoiceLinkCompensated = Constants.BLOCKCHAIN_URL + this.factoring.hash[0];
                        this.invoiceLinkCleared = Constants.BLOCKCHAIN_URL + this.factoring.hash[0];
                        this.bonus = this.factoring.platformComission;
                    }
                })
                .catch((err) => {
                    console.log("ERROR: " + err);
                })
                .finally(() => {
                    
                });
        },
        getName (user) {
            if (user) {
                return user.getName();
            }
            return "";
        },
        goBack () {
            this.$router.push({name: 'home', replace: true}).catch((e) => { console.log(e); });
        }
    }
};
</script>

<style scoped>
</style>
